var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,32H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H27a5.006,5.006,0,0,1,5,5V27A5.006,5.006,0,0,1,27,32ZM5,2A3,3,0,0,0,2,5V27a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,17a1,1,0,0,1-1-1V10a1,1,0,0,1,1.447-.895l6,3a1,1,0,0,1,0,1.79l-6,3A1,1,0,0,1,13,17Zm1-5.382v2.764L16.764,13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,28H6a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,24H1a1,1,0,0,1,0-2H31a1,1,0,0,1,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.bd61ccd633ad192e9e310e0b43515121.svg";
export { ForwardRef as ReactComponent };